var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09082 6.09082H11.909",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09082 9H11.909",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09082 11.9092H8.99991",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6078 17H1.72727C1.53439 17 1.3494 16.9234 1.21301 16.787C1.07662 16.6506 1 16.4656 1 16.2727V1.72727C1 1.53439 1.07662 1.3494 1.21301 1.21301C1.3494 1.07662 1.53439 1 1.72727 1H16.2727C16.4656 1 16.6506 1.07662 16.787 1.21301C16.9234 1.3494 17 1.53439 17 1.72727V11.6078C17 11.7034 16.9812 11.7979 16.9446 11.8862C16.9081 11.9744 16.8545 12.0546 16.787 12.1221L12.1221 16.787C12.0546 16.8545 11.9744 16.9081 11.8862 16.9446C11.7979 16.9812 11.7034 17 11.6078 17Z",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 11.9092H11.9092V17.0001",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobNumber);
export default __webpack_public_path__ + "static/media/job_number.52ac4fbf99998f0585b54a5c4cdb48c7.svg";
export { ForwardRef as ReactComponent };